<template>
  <div class="app-page-not-found">
    <template v-if="pageCanBeOpenedInApp">
      <AppPageNotFoundHeader action-name="Download App" :action-to="downloadAppUrl">
        <template #content>
          <p>This page can only be opened in The Cultivist App.</p>
          <p>If you haven't downloaded it yet, follow the link below.</p>
        </template>
      </AppPageNotFoundHeader>
    </template>

    <template v-else-if="pageCanBeOpenedInApp !== null">
      <AppPageNotFoundHeader />
      <AppPageNotFoundContent />
    </template>
  </div>
</template>

<script>
import AppConfig from '@/config';
import AppContainer from '@/components/AppContainer.vue';
import AppPageNotFoundHeader from '@/components/AppPageNotFoundHeader.vue';

export default {
  components: {
    AppContainer,
    AppPageNotFoundHeader,
    AppPageNotFoundContent: () => import('@/components/AppPageNotFoundContent.vue'),
  },
  metaInfo: {
    title: 'Page not found',
  },
  data() {
    return {
      downloadAppUrl: AppConfig.getAsString('linktrUrl'),
      pageCanBeOpenedInApp: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-page-not-found {
  padding-top: 84px;

  @media (min-width: vars.$tablet-break-point + 1) {
    padding-top: 100px;
  }
}
</style>
